import { logger } from "./logger";

export const trackSignup = () => {
  logger("[LinkedIn] Tracking signup");
  window.lintrk?.("track", { conversion_id: 17252418 });
};

export const trackBuyButtonClick = () => {
  logger("[LinkedIn] Tracking buy button click");
  window.lintrk?.("track", { conversion_id: 17252426 });
};
